export type GalleryCategory = 'Plaster' | 'Tile' | 'Coping' | 'Spray Deck' | 'Remodel'

export interface GalleryItem {
  src: string
  alt: string
  title: string
  location: string
  scope: string
  category: GalleryCategory
  note: string
  duration: string
}

export const galleryCategories: GalleryCategory[] = [
  'Plaster',
  'Tile',
  'Coping',
  'Spray Deck',
  'Remodel',
]

export const galleryItems: GalleryItem[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/tqEq5vwfnYfc27fKjQqnVc/aj2.png',
    alt: 'Freeform pool with raised flagstone spa, rock waterfall, and stamped concrete deck at sunset',
    title: 'Flagstone spa & waterfall remodel',
    location: 'Cypress, TX',
    scope: 'Remodel · Coping · Spa',
    category: 'Remodel',
    note: 'Raised spa rebuilt with flagstone, new rock waterfall, and fresh coping around the entire perimeter.',
    duration: '4 weeks',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iqDsM26qhHXWGfc8GgAmhy/aj1.png',
    alt: 'Freeform pool with attached round spa, white plaster finish, and blue glass waterline tile',
    title: 'Replaster with blue glass waterline tile',
    location: 'Houston, TX',
    scope: 'Plaster · Tile',
    category: 'Plaster',
    note: 'Full chip-out, white plaster finish, and a new glass waterline band that follows every curve.',
    duration: '3 weeks',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nSfvXmgt5vEKw6Rs9JL5a1/aj3.png',
    alt: 'Modern geometric pool with fully tiled raised spa in blue glass mosaic beside a lake',
    title: 'Full glass-mosaic spa',
    location: 'Sugar Land, TX',
    scope: 'Remodel · Tile · Coping',
    category: 'Tile',
    note: 'Every face of the raised spa wrapped in glass mosaic, with marble coping set dead level.',
    duration: '5 weeks',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hJHnJfR9FAxqQo2unkWTwt/aj4.png',
    alt: 'Freeform pool with crystal clear turquoise water, new plaster, rock feature, and raised spa',
    title: 'Crystal finish replaster',
    location: 'Spring, TX',
    scope: 'Plaster · Coping',
    category: 'Plaster',
    note: 'Premium quartz finish over a fully prepped shell — the reason the water reads this clear.',
    duration: '3 weeks',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mdZKBiFp5Fn75JeNgV5WDE/aj8.png',
    alt: 'Freeform pool with deep blue water, flagstone coping, rock waterfall and raised stone spa',
    title: 'Flagstone coping & rock waterfall',
    location: 'Tomball, TX',
    scope: 'Coping · Plaster',
    category: 'Coping',
    note: 'Hand-cut flagstone coping reset stone by stone, with a dark plaster finish underneath.',
    duration: '4 weeks',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/tChdByEC8keKVmxmpqgJ5g/aj9.png',
    alt: 'Modern rectangular pool with attached spa, bubblers, and travertine deck between two homes',
    title: 'Rectangular pool & spa remodel',
    location: 'Houston Heights, TX',
    scope: 'Remodel · Tile · Deck',
    category: 'Remodel',
    note: 'Tight urban lot rebuilt end to end: spa spillway, dark finish, and full travertine decking.',
    duration: '6 weeks',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bdPaTCZoKhp2dErA33B8tq/aj10.png',
    alt: 'Pool and raised spa framed by red brick coping with deep blue waterline tile, surrounded by trees',
    title: 'Brick coping with blue waterline tile',
    location: 'The Woodlands, TX',
    scope: 'Tile · Coping',
    category: 'Tile',
    note: 'Original brick coping restored and paired with a deep blue tile band on pool and spa.',
    duration: '3 weeks',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4cEFGNejTUjjvmhuppfpU2/aj11.png',
    alt: 'Kidney-shaped pool with bright turquoise water and exposed aggregate coping behind a white brick home',
    title: 'Bright white replaster',
    location: 'Pearland, TX',
    scope: 'Plaster · Coping',
    category: 'Plaster',
    note: 'A 20-year-old shell brought back to bright white, with the aggregate coping cleaned and sealed.',
    duration: '3 weeks',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/p6Fr8MHuwbp3KC6bhmKzLi/aj12.png',
    alt: 'Freeform pool with round spa and freshly resurfaced white textured spray deck at golden hour',
    title: 'Spray deck resurfacing & spa refresh',
    location: 'Katy, TX',
    scope: 'Spray deck · Tile',
    category: 'Spray Deck',
    note: 'Cracked cool deck patched, re-textured, and recolored so the whole deck reads as one surface.',
    duration: '2 weeks',
  },
]
